import { useEffect, useState } from "react";
import api from "@/lib/api";

export const REFERENCE_FALLBACK = {
  lead_sources: [
    "Referral", "LinkedIn", "Facebook", "WhatsApp", "Church Network",
    "Previous Client", "Networking Event", "Website", "Cold Outreach", "Credit Union Contact",
  ],
  stages: [
    "New Lead", "Initial Contact", "Discovery Meeting", "Needs Assessment",
    "Proposal Drafting", "Proposal Sent", "Negotiation", "Won", "Lost",
  ],
  services: [
    "Leadership Development", "Communication Excellence", "Emotional Intelligence",
    "Conflict Resolution", "Team Collaboration & Accountability", "Customer Service Excellence",
    "Student Leadership Development", "Parent & Community Engagement",
    "Supervisor Development", "Professional Communication", "Workplace Behaviour & Etiquette",
    "Strategic Planning Facilitation", "Sales & Service Excellence",
    "AI for Managers", "Custom Workshops",
  ],
  workshop_statuses: ["Scheduled", "In Progress", "Completed", "Cancelled"],
  proposal_statuses: ["Draft", "Sent", "Accepted", "Rejected", "Expired"],
  expense_categories: [
    "Travel", "Fuel", "Accommodation", "Printing", "Refreshments",
    "Marketing", "Software Subscriptions", "Internet", "Training Materials",
    "Venue Rental", "Administrative Costs", "Other",
  ],
  engagement_types: ["workshop", "consulting", "marketing", "admin"],
  contact_methods: ["Email", "Phone", "WhatsApp"],
  ccs_framework: {
    Communicate: ["Communication Skills", "Professionalism", "Active Listening", "Difficult Conversations"],
    Collaborate: ["Teamwork", "Accountability", "Respect", "Conflict Management"],
    Serve: ["Customer Service", "Internal Service", "Service Excellence", "Relationship Building"],
  },
};

export function useReference() {
  const [data, setData] = useState(REFERENCE_FALLBACK);
  useEffect(() => {
    api.get("/reference").then((r) => setData(r.data)).catch(() => {});
  }, []);
  return data;
}
